import React from 'react';
import { Tabs } from './ui/Tabs';

export default function StudentTabs({ tabs, active, onChange }) {
  return (
    <Tabs
      tabs={tabs}
      active={active}
      onChange={onChange}
      ariaLabel="Student profile sections"
      idBase="student-profile"
    />
  );
}
